export function ResultsSection() {
  const results = [
    {
      name: 'Aさん',
      grade: '中1',
      subject: '数学',
      before: 45,
      after: 72,
      improvement: 27,
      comment: '計算ミスが減り、文章題も解けるようになりました'
    },
    {
      name: 'Bさん',
      grade: '中2',
      subject: '英語',
      before: 50,
      after: 80,
      improvement: 30,
      comment: '文法が理解できて、長文も読めるようになりました'
    },
    {
      name: 'Cさん',
      grade: '中1',
      subject: '5教科合計',
      before: 280,
      after: 365,
      improvement: 85,
      comment: '提出物を出すようになり、内申点も上がりました'
    },
    {
      name: 'Dさん',
      grade: '中2',
      subject: '数学',
      before: 38,
      after: 68,
      improvement: 30,
      comment: '苦手だった図形問題が得意になりました'
    },
    {
      name: 'Eさん',
      grade: '中1',
      subject: '英語',
      before: 55,
      after: 82,
      improvement: 27,
      comment: '単語の覚え方を教わって、テストで高得点が取れました'
    },
    {
      name: 'Fさん',
      grade: '中2',
      subject: '5教科合計',
      before: 310,
      after: 398,
      improvement: 88,
      comment: '勉強のやり方がわかって、全体的に点数が上がりました'
    }
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black text-gray-800 mb-4">
            成績アップ実績
          </h2>
          <p className="text-sm md:text-base text-gray-600">
            廿日市市の定期テスト対策で、多くの生徒が成績アップを実現
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {results.map((result, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-blue-50 to-white rounded-xl shadow-lg p-6 border-2 border-blue-100 hover:shadow-xl transition-all"
            >
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h3 className="text-lg font-bold text-gray-800">{result.name}</h3>
                  <p className="text-sm text-gray-600">{result.grade} / {result.subject}</p>
                </div>
                <div className="bg-orange-500 text-white px-4 py-2 rounded-full">
                  <span className="text-xl font-black">+{result.improvement}</span>
                  <span className="text-xs ml-1">点</span>
                </div>
              </div>

              <div className="flex items-center gap-4 mb-4">
                <div className="flex-1 text-center">
                  <p className="text-xs text-gray-500 mb-1">受講前</p>
                  <p className="text-3xl font-black text-gray-400">{result.before}</p>
                  <p className="text-xs text-gray-500">点</p>
                </div>
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-3xl text-blue-600"></i>
                </div>
                <div className="flex-1 text-center">
                  <p className="text-xs text-gray-500 mb-1">受講後</p>
                  <p className="text-3xl font-black text-blue-600">{result.after}</p>
                  <p className="text-xs text-gray-500">点</p>
                </div>
              </div>

              <div className="bg-white rounded-lg p-3 border border-blue-100">
                <p className="text-sm text-gray-700 leading-relaxed">
                  <i className="ri-chat-quote-line text-blue-600 mr-1"></i>
                  {result.comment}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-center text-white shadow-xl">
          <h3 className="text-2xl md:text-3xl font-black mb-3">
            あなたも成績アップできます
          </h3>
          <p className="text-sm md:text-base mb-2 leading-relaxed">
            <strong>苦手克服</strong>から<strong>成績アップ</strong>まで、一人ひとりに合わせた指導で確実にサポート。<br />
            まずは無料体験で、当塾の授業を体感してください。
          </p>
        </div>
      </div>
    </section>
  );
}
